const sliceDate = (date) => {
  if (date) return date.slice(0, 19);
  return null;
};

const roundFloat = (float) => {
  if (float === 0) return float;

  if (float) return float.toFixed(2);
  return null;
};

const requestTypeConverter = (requestType) => {
  const types = [...requestType];
  const typesArray = [];

  types.forEach((type) => {
    const obj = { value: type, label: type };
    typesArray.push(obj);
  });

  return typesArray;
};

const getRequestTypeArray = (requestType) => {
  const types = [...requestType];
  const typesArray = [];

  types.forEach((type) => {
    const stringType = type?.value;
    typesArray.push(stringType);
  });

  return typesArray;
};

const downloadBlob = (content, filename, contentType) => {
  const blob = new Blob([content], { type: contentType });
  const url = URL.createObjectURL(blob);

  const pom = document.createElement('a');
  pom.href = url;
  pom.setAttribute('download', filename);
  pom.click();

  if (pom.parentNode) pom.parentNode.removeChild(pom);
};

export { roundFloat, requestTypeConverter, downloadBlob, getRequestTypeArray };
export default sliceDate;
